<template>
    <div>
        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="devId" label="设备编号">
            </el-table-column>
            <el-table-column prop="termVersion" label="设备型号">
            </el-table-column>
            <el-table-column prop="termName" label="型号名称">
            </el-table-column>
            <el-table-column prop="location" label="货架位置">
            </el-table-column>
            <el-table-column prop="stockStatus" label="状态">
                <template slot-scope="scope">
                    {{scope.row.stockStatus | status}}
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                termVersion: '',
                devId:'',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        filters:{
            status(value) {
                switch(value) {
                    case "0": return '待入库';break;
                    case "1": return '入库';break;
                    case "2": return '出库';break;
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if (this.termVersion.trim() != '') {
                    params.termVersion = this.termVersion;
                }
                if (this.devId.trim() != '') {
                    params.devId = this.devId;
                }
                this.$http.post('/manage/stock/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            }
        },
        components: { Pagination }
    }
</script>